import React, {useState} from "react";
import './dragDrop.scss';
import PropTypes from 'prop-types';
import Draggable from "react-draggable";
import {observer} from "mobx-react";
import {itemTypeEnum} from "../../enums";
import {useStores} from "../../Hooks";
import Utility from "../../Utility";
import {ObservableMap} from "mobx";
import {dataStore} from "../../index";

const Drag = observer(props => {
    const {dragStore, generalStore, projectStore, modalStore, procedureStore} = useStores();
    const [isDragging, setIsDragging] = useState(false);
    const {itemId, itemType, isSlave, dontDrag, children, disabled} = props;

    function handleDrag(e, ui) {
        e.preventDefault();
        e.stopPropagation();
        dragStore.dragItemId = itemId;
        setIsDragging(true);
        const {x: previousX, y: previousY} = dragStore.controlledDelta;
        dragStore.controlledDelta = {
            x: previousX + ui.deltaX,
            y: previousY + ui.deltaY
        }
    }

    async function handleStop(e) {
        if (dragStore.isBlocked) {
            clearDrag();
            return;
        }
        if (!isDragging) {
            if (props.onClick && e.detail === 1) {
                props.onClick()
            }
            if (props.onDoubleClick && e.detail === 2) {
                props.onDoubleClick();
            }
            return;
        }
        if (dragStore.dropItemId) {
            await drop();
        }
        clearDrag();
    }

    function clearDrag() {
        dragStore.dragItemId = null;
        setIsDragging(false);
    }

    function checkIsFolderMirrored() {
        const projectFoldersMap = dataStore.projectsFoldersMap.get(projectStore.currentProject?.ProjectIdentifier) || new ObservableMap();
        projectFoldersMap.forEach((folderData, folderId) => {
            if (itemId === folderId && folderData?.importedFromWorkspace) {
                generalStore.isLoaderOpen = false;
                modalStore.showErrorMessage(generalStore.translate("can'tModifyASharedItem"));
                return true
            }
        });
        return false
    }

    function checkIsProcedureMirrored() {
        const projectProceduresMap = dataStore.projectsProceduresMap.get(projectStore.currentProject?.ProjectIdentifier) || new ObservableMap();
        projectProceduresMap.forEach((procedureData, procedureId) => {
            if (itemId === procedureId && procedureData?.importedFromWorkspace) {
                generalStore.isLoaderOpen = false;
                modalStore.showErrorMessage(generalStore.translate("can'tModifyASharedItem"));
                return true
            }
        });
        return false
    }

    async function drop() {
        try {
            generalStore.isLoaderOpen = true;

            if (itemTypeEnum.FOLDER === itemType && checkIsFolderMirrored()) {
                return
            }
            if (itemTypeEnum.PROCEDURE === itemType && checkIsProcedureMirrored()) {
                return
            }

            const destinationId = dragStore.dropItemId;
            await dragStore.drop(itemId, itemType, projectStore.currentProject?.ProjectIdentifier, procedureStore.currentProcedure?.ProcedureIdentifier);
            await projectStore.refreshProjectDetails();

            if (modalStore.isMediaLibraryModalOpen) {
                modalStore.isMediaLibraryModalOpen = false;
                modalStore.isMediaLibraryModalOpen = true;
            }
            if (props.onFinishDrag) {
                await props.onFinishDrag(destinationId);
            }
        } catch (e) {
            console.error(e);
            modalStore.showErrorMessage('problem moving');
        }
        generalStore.isLoaderOpen = false;
    }

    if (Utility.isTouchDevice()) {
        return (
            <div onClick={props.onClick}>
                {children}
            </div>
        )
    }
    return (
        <Draggable
            onDrag={handleDrag}
            onStop={handleStop}
            cancel={dontDrag}
            position={!isSlave ? {x: 0, y: 0} : dragStore.controlledDelta}
            disabled={disabled}
        >
            <div className={isDragging || isSlave ? 'dragged' : ''}>
                {children}
            </div>
        </Draggable>
    )
});

Drag.propTypes = {
    itemId: PropTypes.string.isRequired,
    itemType: PropTypes.oneOf([...Object.values(itemTypeEnum)]),
    onClick: PropTypes.func,
    dontDrag: PropTypes.string,
    isSlave: PropTypes.bool,
    disabled: PropTypes.bool,
    onFinishDrag: PropTypes.func,
};
export default Drag;
